/**
 * TayTae Cart Drawer
 * - AJAX add-to-cart (window.TayTae.addToCart)
 * - Slide-out cart drawer with live item rendering
 * - Header cart count badge sync
 */
(function() {
  'use strict';

  /* ── Global namespace ──────────────────────────────────── */
  window.TayTae = window.TayTae || {};

  /* ── DOM references ────────────────────────────────────── */
  var drawer         = document.getElementById('cartDrawer');
  var overlay        = document.getElementById('overlay');
  var itemsContainer = document.getElementById('cartDrawerItems');
  var subtotalEl     = document.getElementById('cartDrawerSubtotal');
  var countEl        = document.getElementById('cartDrawerCount');
  var headerCountEl  = document.getElementById('headerCartCount');
  var emptyState     = document.getElementById('cartDrawerEmpty');
  var filledState    = document.getElementById('cartDrawerFilled');
  var closeBtn       = document.getElementById('cartDrawerClose');
  var continueBtn    = document.getElementById('cartDrawerContinue');

  /* ── Drawer open / close ───────────────────────────────── */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* ── Format cents → "$X.XX" ────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Resize Shopify CDN image URL ──────────────────────── */
  function sizedImageUrl(url, width) {
    if (!url) return '';
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'width=' + width;
  }

  /* ── Update header cart count badge ────────────────────── */
  function updateHeaderCount(count) {
    if (!headerCountEl) return;
    headerCountEl.textContent = count;
    if (count > 0) {
      headerCountEl.classList.remove('is-hidden');
      /* Add bounce class to cart icon link */
      var cartLink = headerCountEl.closest('.header__icon-link');
      if (cartLink) cartLink.classList.add('header__cart-link--has-items');
    } else {
      headerCountEl.classList.add('is-hidden');
    }
  }

  /* ── Render full cart into the drawer ───────────────────── */
  function renderCart(cart) {
    if (!itemsContainer) return;

    /* Update count + subtotal */
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateHeaderCount(cart.item_count);

    /* Toggle empty vs filled state */
    if (cart.item_count === 0) {
      if (emptyState)  emptyState.style.display = 'block';
      if (filledState) filledState.style.display = 'none';
      return;
    }
    if (emptyState)  emptyState.style.display = 'none';
    if (filledState) filledState.style.display = 'flex';

    /* Build item HTML */
    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = item.image ? sizedImageUrl(item.image, 180) : '';
      html += '<div class="cart-drawer__item" data-line-key="' + item.key + '">';
      html += '  <div class="cart-drawer__item-image">';
      if (imgSrc) {
        html += '  <img src="' + imgSrc + '" alt="' + (item.product_title || '') + '" loading="lazy">';
      }
      html += '  </div>';
      html += '  <div class="cart-drawer__item-details">';
      html += '    <p class="cart-drawer__item-title">' + item.product_title + '</p>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '  <p class="cart-drawer__item-variant">' + item.variant_title + '</p>';
      }
      html += '    <p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '    <div class="cart-drawer__item-qty">';
      html += '      <button class="cart-drawer__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">-</button>';
      html += '      <span class="cart-drawer__qty-value">' + item.quantity + '</span>';
      html += '      <button class="cart-drawer__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">+</button>';
      html += '    </div>';
      html += '  </div>';
      html += '  <button class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="Remove item">';
      html += '    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
      html += '  </button>';
      html += '</div>';
    });
    itemsContainer.innerHTML = html;
  }

  /* ── Fetch /cart.json and re-render ────────────────────── */
  function fetchAndRenderCart() {
    return fetch('/cart.json')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        return cart;
      });
  }

  /* ── AJAX Add to Cart ──────────────────────────────────── */
  window.TayTae.addToCart = function(variantId, quantity) {
    return fetch('/cart/add.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function() {
      /* Fetch updated cart, render, then open drawer */
      return fetchAndRenderCart();
    })
    .then(function() {
      openDrawer();
    });
  };

  /* ── Update item quantity (also handles remove when qty=0) */
  function updateItemQuantity(key, quantity) {
    return fetch('/cart/change.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCart(cart);
    });
  }

  /* ── Event listeners ───────────────────────────────────── */

  /* Close button */
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  /* Continue Shopping button */
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

  /* Overlay click — close drawer if it's the one that's open */
  if (overlay) {
    overlay.addEventListener('click', function() {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* Escape key */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Qty buttons + remove — event delegation on items container */
  if (itemsContainer) {
    itemsContainer.addEventListener('click', function(e) {
      /* Qty increase / decrease */
      var actionBtn = e.target.closest('[data-action]');
      if (actionBtn) {
        var key    = actionBtn.dataset.key;
        var qtyEl  = actionBtn.parentElement.querySelector('.cart-drawer__qty-value');
        var curQty = parseInt(qtyEl.textContent) || 1;
        if (actionBtn.dataset.action === 'decrease') {
          updateItemQuantity(key, Math.max(0, curQty - 1));
        } else {
          updateItemQuantity(key, curQty + 1);
        }
        return;
      }
      /* Remove button */
      var removeBtn = e.target.closest('.cart-drawer__item-remove');
      if (removeBtn) {
        updateItemQuantity(removeBtn.dataset.key, 0);
      }
    });
  }

  /* ── Expose helpers for other scripts ──────────────────── */
  window.TayTae.openCartDrawer  = openDrawer;
  window.TayTae.closeCartDrawer = closeDrawer;

})();
